import React from 'react';
import { Construction } from 'lucide-react';

export function Insights() {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-brand-teal">Company Insights</h1>
        <p className="mt-1 text-sm text-gray-500">
          Search and discover insights across all interview projects
        </p>
      </div>

      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 rounded-lg">
        <div className="flex flex-col items-center justify-center py-16 px-4">
          <Construction className="h-12 w-12 text-brand-orange mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Coming Soon</h2>
          <p className="text-gray-500 text-center max-w-md">
            Our advanced insights system is under development. Soon you'll be able to 
            search and analyze customer feedback across all your projects.
          </p>
        </div>
      </div>
    </div>
  );
}